import React, { useState, useEffect } from 'react'
import './Navbar.scss'
import { images } from '../../constants'
import { withRouter, Link } from 'react-router-dom'
import Hamburger from './Hamburger'
import logo from "./../../assets/images/logo.png"
const Navbar = ({ history }) => {
  const [state, setState] = useState({
    initial: false, //轉乘null 不是true
    clicked: null,
    menuName: "Menu"
    // menuName: "Menu" 只是轉換名 menuName: "close"
  });
  // State of button
  const [disabled, setDisabled] = useState(false);
  //跳轉變回Menu
  useEffect(() => {
    //Listening for page changes.
    history.listen(() => {
      setState({ clicked: false, menuName: "Menu" });
    });
  }, [history]);

  const handleMenu = () => {
    disableMenu();
    if (state.initial === false) {
      setState({
        initial: null,
        clicked: true,
        menuName: "Close"
      });
      //   console.log(1)第一次特效才要這樣寫 transition loading
    } else if (state.clicked === true) {
      setState({
        clicked: !state.clicked,
        menuName: "Menu"
      });
      //   console.log(2)
    } else if (state.clicked === false) {
      setState({
        clicked: !state.clicked,
        menuName: "Close"
      });
      //   console.log(3)
    }
  };
  //Determine if out menu button should be disabled
  const disableMenu = () => {
    setDisabled(!disabled);
    setTimeout(() => {
      setDisabled(false);
    }, 1200);
  };

  return (
    <>
      <div className="navbar">
        <div className="container">
          <div className="inner-navbar">
            <Link to="/">
              <div className="logo">
                <img src={logo} alt='logo' />

                <span>宇宙波波
                </span>

              </div></Link>
            <div className="menu" >
              <button className="outline" disabled={disabled} onClick={handleMenu}>
                <a>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  宇宙菜單
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 9.5H7M21 4.5H3M21 14.5H3M21 19.5H7" /></svg>

                </a>
              </button>
            </div>
          </div>
        </div>
        <Hamburger state={state} />
      </div>

      {/* <div className="navgation">
        <ul>
          <li className="list">
            <a href="/">
              <span className="icon"></span>
              <span className="text">首頁</span>
            </a>
          </li>
          <li className="list">
            <a href="/">
              <span className="icon"></span>
              <span className="text">起源</span>
            </a>
          </li>
          <li className="list">
            <a href="/">
              <span className="icon"></span>
              <span className="text">夥伴</span>
            </a>
          </li>
          <li className="list">
            <a href="/">
              <span className="icon"></span>
              <span className="text">商品</span>
            </a>
          </li>
        </ul>
      </div>*/}
    </>
  )
}

export default withRouter(Navbar)
//withRouter(Navbar) 跳轉順利不讓menu關不起來